import React from 'react';
import { ThemedText, ThemedView } from "@app/theme";
import Button from "@sharedComponents/Button/Button";
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon';

interface PhotoActionButtonProps {
    hasPhoto: boolean;
    onCapture: () => void;
    onUpload: () => void;
    isLoading: boolean;
    colors: any;
    showPartnerView: boolean;
    onPressShareLink: () => void;
}

export const PhotoActionButton: React.FC<PhotoActionButtonProps> = ({
                                                                        hasPhoto,
                                                                        onCapture,
                                                                        onUpload,
                                                                        isLoading,
                                                                        colors,
                                                                        showPartnerView,
                                                                        onPressShareLink,
                                                                    }) => (
    <ThemedView
        style={{width: '100%'}}
        bg='bg-surface-primary'
        padding='lg'
        borderTopWidth={1}
        borderTopColor='border-primary'
    >
         <ThemedView mb='sm' flexDirection='row' justifyContent='center' alignItems='center'>
          <ShieldCheckIcon size={14} />
          <ThemedText textAlign='center' ml='sm' color='text-emphasis-secondary' variant='b4r'>
            Your data is secure with us
          </ThemedText>
        </ThemedView>
        <Button
            eventName={hasPhoto ? 'KYC_PHOTO_VERIFICATION_UPLOAD_SELFIE' : 'KYC_PHOTO_VERIFICATION_CAPTURE_SELFIE'}
            label={hasPhoto ? "Upload selfie" : "Capture selfie"}
            type="SOLID"
            size='MD'
            disabled={false}
            handlePress={hasPhoto ? onUpload : onCapture}
            bg={colors['bg-action-primary']}
            buttonLoader={isLoading}
            textColor={colors['text-primary']}
        />
        {
            showPartnerView && (
                <ThemedView alignItems='center' justifyContent='center' marginTop='lg'>
                    <Button
                        label={"Share link with customer"}
                        type="TEXT"
                        size='MD'
                        disabled={false}
                        handlePress={()=>{
                            onPressShareLink && onPressShareLink()
                        }}
                        textColor={colors['text-primary']}
                    />
                </ThemedView>
            )
        }
    </ThemedView>
);